import Tooltip from "@insite/mobius/Tooltip/Tooltip";

export default Tooltip;

export * from "./Tooltip";
